const jQueryBridget = require('jquery-bridget');
const Flickity = require('flickity');
Flickity.setJQuery( $ );
jQueryBridget('flickity', Flickity, $);

export function imageGallery() {
  const $target = $('.js-image-carousel');
  if ($target[0]) {
    $target.each(function() {
      const $this = $(this);
      if ($this.find('.js-carousel-cell')[1]) {
        $this.flickity({
          cellSelector: '.js-carousel-cell',
          cellAlign: 'left',
          wrapAround: true,
          prevNextButtons: true,
          pageDots: true,
          autoPlay: 3000,
          arrowShape: {
            x0: 30,
            x1: 60,
            y1: 30,
            x2: 65,
            y2: 30,
            x3: 35
          }
        });
      }
    });
  }
}